/* eslint-disable */

//import fitvids from 'fitvids';
import 'jquery';
// import '../lib/jquery-eu-cookie-law-popup';
// import jcf from 'jcf/dist/js/jcf';
// import 'jcf/dist/js/jcf.select';
// import 'jcf/dist/js/jcf.checkbox';
// import 'parsleyjs/dist/parsley';
// import 'slick-carousel/slick/slick';
// import 'magnific-popup/dist/jquery.magnific-popup';
import List from 'list.js';
// import * as typeformEmbed from '@typeform/embed';

// import anime from 'animejs';

export default {
  init() {
    // JavaScript to be fired on all pages
    //fitvids('.video-container');
    // this.portfolio();
    // this.dynamicMenu();



    this.accordion();
    this.mobileMenuSticky();
    this.mobileMenu();
    this.stickyNavigation();
    this.smoothAnchors();
    // this.initCarousel();
    // this.resize();


    // this.cookiePopup();


    // this.newsletter();
    this.portfolioFilter();
    this.exitsFilter();
    // this.typeform();
    // this.dataLayer();
    // this.magnificPopup();
    // this.checkHash();



  },
  // portfolio() {
  //   jQuery(document).ready(() => {
  //     $('.company').on('mouseover', event => {
  //       // console.log(event.target.parentNode);
  //       if (!event.target.parentNode.classList.contains('active')) {
  //         event.target.parentNode.classList.add('active');
  //         event.target.parentNode.querySelector('.company__logo').classList.add('active');
  //         event.target.parentNode.querySelector('.company__content').classList.add('active');
  //       }
  //     });
  //     $('.company').on('mouseout', event => {
  //       // console.log(event.target.parentNode);
  //       if (event.target.parentNode.classList.contains('active')) {
  //         event.target.parentNode.classList.remove('active');
  //         event.target.parentNode.querySelector('.company__logo').classList.remove('active');
  //         event.target.parentNode.querySelector('.company__content').classList.remove('active');
  //       }
  //     });
  //   });
  // },
  accordion() {
    jQuery(document).ready(() => {
      let handles = document.querySelectorAll('.accordion__item');
      let contentAll = document.querySelectorAll('.accordion__content');

      let toggleAllAccordions = () => {
        handles.forEach((handle, index) => {
          contentAll[index].classList.remove('active');
          handle.classList.remove('active');
        });
      }

      handles.forEach((handle, index) => {
        handle.addEventListener('click', () => {
          let content = handle.querySelector('.accordion__content');
          let state = false;

          if (handle.classList.contains('active')) {
            handle.classList.remove('active');
            content.classList.remove('active');
          } else {
            state = true; // only place a delay if an accordion has already been opened
            if (state) {
              toggleAllAccordions();
              setTimeout(() => {
                handle.classList.add('active');
                content.classList.add('active');
              }, 300);
            } else {
              handle.classList.add('active');
              content.classList.add('active');
            }
          }
        });
      });
    });
  },
  mobileMenuSticky() {
    jQuery(document).ready(() => {
      let hamburger = $('.hamburger-icon--sticky');
      let header = $('.sticky-nav');
      let menu = $('.mobile-menu--sticky');

      hamburger.click(() => {
        hamburger.toggleClass('active');
        header.toggleClass('active');
        menu.toggleClass('active');
      });
    });
  },
  mobileMenu() {
    jQuery(document).ready(() => {
      let hamburger = $('.hamburger-icon');
      let header = $('.header');
      let menu = $('.mobile-menu');
      let hero = $('.hero');
      let main = $('main.main');
      let active = false;

      hamburger.click(() => {
        active = !active;
        active ? main[0].style.position = "fixed" : main[0].style.position = "";
        hamburger.toggleClass('active');
        header.toggleClass('active');
        menu.toggleClass('active');
        hero.toggleClass('active');
        return false;
      });
    });
  },
  stickyNavigation() {
    const removeHash = () => {
      history.pushState("", document.title, window.location.pathname + window.location.search);
    }

    jQuery(function ($) {
      var mywindow = $(window);
      var mypos = mywindow.scrollTop();
      let scrolling = false;
      window.addEventListener('scroll', function () {
        scrolling = true;
      });
      setInterval(() => {
        if (scrolling) {
          let menu = $('.mobile-menu--sticky');
          let height = $('.hero').height();

          setTimeout(() => {
            // history.replaceState(null, null, ' ');
            removeHash();
          }, 1500);

          scrolling = false;

          if (!window.location.hash) {

            if (!menu.hasClass('active')) {
              if (mywindow.scrollTop() < mypos && mypos > height) {
                $('.sticky-nav').addClass('headerup');
              } else {
                $('.sticky-nav').removeClass('headerup');
              }
            }
          }

          mypos = mywindow.scrollTop();
        }
      }, 150);
    });
  },
  smoothAnchors() {
    document.querySelectorAll('a[href^="#"]:not(.hamburger-icon)').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        let hamburger = $('.hamburger-icon, .hamburger-icon--sticky');
        let header = $('.header, .sticky-nav');
        let menu = $('.mobile-menu, .mobile-menu--sticky');
        let hero = $('.hero');
        let main = $('.main');
        hamburger.removeClass('active');
        header.removeClass('active');
        menu.removeClass('active');
        hero.removeClass('active');
        // document.body.style.position = "";
        main[0].style.position = "";

        setTimeout(() => {
          document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
          });
        }, 500);
      });
    });
  },
  checkHash() {
    jQuery(function ($) {
      let hash = window.location.hash;

      if (hash.length > 0) {
        let btn = $(`button.filter[data-slug="${hash.substr(1)}"]`);

        if (btn.length) {
          btn.click();
        }
      }
    });
  },
  // magnificPopup() {
  //   jQuery(function ($) {
  //     const isCompanyPage = document.body.classList.contains("single-cf_company");
  //     if (!isCompanyPage) {
  //       $('a[href*="youtube.com"]').magnificPopup({
  //         type: 'iframe',
  //         iframe: {
  //           markup: '<div class="mfp-iframe-scaler">' +
  //             '<div class="mfp-close"></div>' +
  //             '<iframe class="mfp-iframe " frameborder="0" allowfullscreen></iframe>' +
  //             '</div>',
  //           patterns: {
  //             youtube: {
  //               index: 'youtube.com/',
  //               id: 'v=',
  //               src: '//www.youtube.com/embed/%id%?autoplay=1&enablejsapi=1&rel=0',
  //             },
  //           },
  //           srcAction: 'iframe_src',
  //         },
  //         callbacks: {
  //           open: function () {
  //             let video = document.getElementsByClassName('mfp-iframe')[0];

  //             if (typeof window.gtmYTListeners !== 'undefined') {
  //               window.gtmYTListeners.push(new window.YT.Player(video, {
  //                 events: {
  //                   onStateChange: window.onPlayerStateChange,
  //                   onError: window.onPlayerError,
  //                 },
  //               }));

  //               window.YT.gtmLastAction = "p";
  //             }
  //           },
  //         },
  //       });
  //     }
  //   });
  // },
  dataLayer() {
    jQuery(function ($) {
      $('a.employee').click((event) => {
        let value = $(event.currentTarget).data('name');

        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            event: 'teammemberClicked',
            value: value,
          });
        }
      });

      $('a.portfolio-company').click((event) => {
        let value = $(event.currentTarget).data('name');

        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            event: 'companyClicked',
            value: value,
          });
        }
      });
    });
  },
  typeform() {
    jQuery(function () {
      let typeform = jQuery('a[href*="typeform.com"]');
      if (typeform.length) {
        /* set urm params, if any */

        typeform.each(function () {
          let params = window.location.search;
          let href = jQuery(this).attr('href');
          $(this).attr('href', href + params);
        });

        typeform.click((event) => {
          event.preventDefault();
          let url = $(event.currentTarget).attr('href');
          let options = {
            mode: 'drawer_right',
          };

          let form = typeformEmbed.makePopup(url, options)
          form.open();
        });
      }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
  portfolioFilter() {

    jQuery(function ($) {
      let options = {
        valueNames: ['name', 'category'],
        pagination: {
          item: '<li><a class="page" href="#portfolio-archive"></a></li>'
        }
      };

      let archive;

      if ($('.home').length) {
        options.page = 12;
        archive = new List('portfolio-archive', options);
        archive.sort('name', { order: "asc" });

      } else {
        options.page = 9;
        archive = new List('archive', options);
      }

      archive.on('updated', list => {

        setTimeout(() => {
          const header = document.querySelector('.sticky-nav');
          header.classList.remove('headerup');
        }, 500);

        list.matchingItems.forEach(function (element) {
          let id = element.elm.id;

          // $('#' + id).addClass('animated fadeIn');
          $('.company').addClass('animate__animated animate__fadeIn');
        });
      });

      // let exits = false;
      // if (document.getElementById('exits')) {
      //   exits = new List('exits', options);
      // }

      $('.post-nav').prepend(`<div class="btn-first">
        <svg xmlns="http://www.w3.org/2000/svg" width="8.835" height="15.357" viewBox="0 0 8.835 15.357">
          <path id="Path_17504" data-name="Path 17504" d="M6806.213,8317l-7.237,7.238,7.237,7.052" transform="translate(-6797.908 -8316.47)" fill="none" stroke="#707070" stroke-width="1.5"/>
        </svg>
      </div>`);

      $('.post-nav').append(`<div class="btn-last">
        <svg xmlns="http://www.w3.org/2000/svg" width="8.835" height="15.357" viewBox="0 0 8.835 15.357">
          <path id="Path_17505" data-name="Path 17505" d="M6806.213,8317l-7.237,7.238,7.237,7.052" transform="translate(6806.743 8331.827) rotate(180)" fill="none" stroke="#707070" stroke-width="1.5"/>
        </svg>
      </div>`);

      $('.btn-first').on('click', function () {
        archive.show(12, 12)
      });

      $('.btn-last').on('click', function () {
        archive.show(archive.size(), 12)
      });

      $('.filter').on('click', (event) => {
        let slug = $(event.currentTarget).data('slug');

        $('button.filter').removeClass('active');
        $(event.currentTarget).addClass('active');

        archive.filter(function (item) {
          let values = item.values().category.split(',');
          values = values.map(x => x.trim());

          // console.log('values', values);

          if (slug === 'all') {
            if (values.indexOf('lp-fund-investments') > -1) {
              return false;
            }
            return true;
          }

          // console.log('Values: ', values.indexOf(slug));

          if (values.indexOf(slug) > -1) {
            return true;
          } else {
            return false;
          }
        });

        // if (exits) {
        //   exits.filter(function (item) {
        //     let values = item.values().category.split(',');
        //     values = values.map(x => x.trim());

        //     if (slug === 'all') {
        //       if (values.indexOf('lp-fund-investments') > -1) {
        //         return false;
        //       }

        //       return true;
        //     }

        //     if (values.indexOf(slug) > -1) {
        //       return true;
        //     } else {
        //       return false;
        //     }
        //   });
        // }

        // let exitsTitle = document.querySelector('#exits .exits-title');
        // if (exitsTitle) {
        //   let exitsCompanies = document.querySelectorAll('#exits .company');
        //   exitsTitle.style.display = (exitsCompanies && exitsCompanies.length) ? 'inline-block' : 'none';
        // }

      });

      $('.filter.active').click();
    });
  },
  exitsFilter() {

    jQuery(function ($) {
      let options = {
        valueNames: ['name', 'category'],
        pagination: {
          item: '<li><a class="page" href="#exits-archive"></a></li>'
        }
      };

      if ($('.home').length) {
        options.page = 12;
      } else {
        return false;
      }


      let archive = new List('exits-archive', options);
      archive.sort('name', { order: "asc" });

      archive.on('updated', list => {
        setTimeout(() => {
          const header = document.querySelector('.sticky-nav');
          header.classList.remove('headerup');
        }, 500);

        list.matchingItems.forEach(function (element) {
          let id = element.elm.id;

          // $('#' + id).addClass('animated fadeIn');
          $('.company').addClass('animate__animated animate__fadeIn');
        });
      });

      // let exits = false;
      // if (document.getElementById('exits')) {
      //   exits = new List('exits', options);
      // }

      $('.post-nav').prepend(`<div class="btn-first">
        <svg xmlns="http://www.w3.org/2000/svg" width="8.835" height="15.357" viewBox="0 0 8.835 15.357">
          <path id="Path_17504" data-name="Path 17504" d="M6806.213,8317l-7.237,7.238,7.237,7.052" transform="translate(-6797.908 -8316.47)" fill="none" stroke="#707070" stroke-width="1.5"/>
        </svg>
      </div>`);

      $('.post-nav').append(`<div class="btn-last">
        <svg xmlns="http://www.w3.org/2000/svg" width="8.835" height="15.357" viewBox="0 0 8.835 15.357">
          <path id="Path_17505" data-name="Path 17505" d="M6806.213,8317l-7.237,7.238,7.237,7.052" transform="translate(6806.743 8331.827) rotate(180)" fill="none" stroke="#707070" stroke-width="1.5"/>
        </svg>
      </div>`);

      $('.btn-first').on('click', function () {
        archive.show(12, 12)
      });

      $('.btn-last').on('click', function () {
        archive.show(archive.size(), 12)
      });

      $('.filter').on('click', (event) => {
        let slug = $(event.currentTarget).data('slug');

        // console.log('Slug:', slug);

        $('button.filter').removeClass('active');
        $(event.currentTarget).addClass('active');

        archive.filter(function (item) {
          let values = item.values().category.split(',');
          values = values.map(x => x.trim());

          // console.log('values', values);

          if (slug === 'all') {
            if (values.indexOf('lp-fund-investments') > -1) {
              return false;
            }
            return true;
          }

          // console.log('Values: ', values.indexOf(slug));

          if (values.indexOf(slug) > -1) {
            return true;
          } else {
            return false;
          }
        });

        if (archive) {
          archive.filter(function (item) {

            let values = item.values().category.split(',');
            values = values.map(x => x.trim());

            if (slug === "all") {
              return true;
            } else {
              return true;
            }
          });
        }

        // if (archive) {
        //   archive.filter(function (item) {
        //     let values = item.values().category.split(',');
        //     values = values.map(x => x.trim());

        //     if (slug === 'all') {
        //       if (values.indexOf('lp-fund-investments') > -1) {
        //         return false;
        //       }

        //       return true;
        //     }

        //     if (values.indexOf(slug) > -1) {
        //       return true;
        //     } else {
        //       return false;
        //     }
        //   });
        // }

        // let exitsTitle = document.querySelector('#exits .exits-title');
        // if (exitsTitle) {
        //   let exitsCompanies = document.querySelectorAll('#exits .company');
        //   exitsTitle.style.display = (exitsCompanies && exitsCompanies.length) ? 'inline-block' : 'none';
        // }

      });

      $('.filter.active').click();
    });
  },

  newsletter() {
    function getClientId() {
      try {
        var trackingId = 'UA-62517590-14';
        var trackers = window.ga.getAll();

        for (var i = 0; i < trackers.length; i++) {
          if (trackers[i].get('trackingId') == trackingId) {
            return trackers[i].get('clientId');
          }
        }
      } catch (error) {
        return 'GA-ID Not Detected';
      }
    }

    jQuery(function () {
      if (jQuery('.newsletter').length) {
        jcf.replaceAll();

        jQuery('#newsletter').parsley({
          classHandler: function (el) {
            return el.$element.closest('.input-group')
          },
        });

        jQuery('#newsletter').on('submit', function (e) {
          e.preventDefault();
          var form = jQuery(this);
          let $ = jQuery;

          form.parsley().validate();

          if (form.parsley().isValid()) {

            let clientId = getClientId();

            $('<input>', {
              type: 'hidden',
              name: 'field[10]',
              value: clientId,
            }).appendTo('form#newsletter');

            let data = form.serialize();

            $.ajax({
              type: 'POST',
              url: form.attr('action'),
              data: data,
              success: function () { },
            });

            if (typeof window.dataLayer !== 'undefined') {
              window.dataLayer.push({
                event: 'sign-up',
                country: $('#newsletter .country option:selected').val(),
              });
            }

            jQuery('#newsletter .thank-you').removeClass('d-none');
            form.trigger("reset");
          }
        });
      }
    });
  },
  // cookiePopup() {
  //   jQuery(function () {
  //     jQuery(document).euCookieLawPopup().init({
  //       cookiePolicyUrl: 'https://www.samsung.com/us/account/privacy-policy/',
  //       popupPosition: 'bottom',
  //       colorStyle: 'default',
  //       compactStyle: false,
  //       popupTitle: 'This website is using cookies',
  //       popupText: 'We use cookies on our website as described in our Privacy Policy, to enhance your browsing experience and we process personal information in the United States which, for users outside the United States, may have a lower standard of data privacy laws compared to your country of residence. Please click Accept to confirm your acceptance to our use of cookies. By continuing to use the website you are deemed to have consented to our use of cookies.',
  //       buttonContinueTitle: 'Accept',
  //       buttonLearnmoreTitle: 'Learn more',
  //       buttonLearnmoreOpenInNewWindow: true,
  //       agreementExpiresInDays: 30,
  //       autoAcceptCookiePolicy: false,
  //       htmlMarkup: null,
  //     });
  //   });
  // },
  resize() {
    jQuery(window).resize(() => {
      $('.section-carousel').slick('unslick');
      this.initCarousel();
    });
  },
  initCarousel(slidesToShow = 2) {
    jQuery(function () {
      let width = $(window).width();
      let slidesToScroll = 2;

      if (width >= 576 && width < 768) {
        slidesToShow = 3;
        //slidesToScroll = 3;
      } else if (width >= 768 && width < 992) {
        slidesToShow = 4;
        //slidesToScroll = 4;
      } else if (width >= 992 && width < 1200) {
        slidesToShow = 5;
        //slidesToScroll = 4;
      } else if (width >= 1200) {
        slidesToShow = 7;
        //slidesToScroll = 4;
      }

      jQuery('.section-carousel').slick({
        infinite: true,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        centerMode: true,
      });

      // page header carousel h2 functionality

      $('#page-header-carousel').on('slide.bs.carousel', function () {
        $('#page-header-title').animate({ opacity: 0 }, 300);
      });


      $('#page-header-carousel').on('slid.bs.carousel', function (event) {
        let title = $(event.relatedTarget).find('h2');

        if (title.length) {
          title = title.html();
          $('#page-header-title').html(title);
          $('#page-header-title').animate({ opacity: 1 }, 300);
        }
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js